export const branchConfig = {
  branchId: "sadang",
  identityDisabled: true, // 미정 TODO — 카카오 심사 완료 후 복원
  integrationsDisabled: true, // 미정 TODO — 외부 차트·결제선생 연동 준비 중

  // 미들웨어 설정 (#878 — middleware.js 에 박혀 있던 옵션).
  // 쿠키 domain 은 한 번 심기면 리버트해도 브라우저에 남는다 — 값을 그대로 옮겼다.
  middleware: {
    localePrefixes: ["en"],
  },

  // 홈 빠른상담 설정 (#874 — homeClient 에 박혀 있던 값).
  homeQuickConsult: {
    enableIdentity: false, // 미정 TODO — 카카오 심사 완료 후 인증 복원
    // 빠른상담 전송 경로 — 현재 코드에서 읽었다 (#874).
    submitVia: null, // 미정 TODO — 외부 차트 전송 없이 접수
  },
  // 홈 구조화 데이터의 기관명 (#874).
  homeJsonLd: { orgNameKo: "끗 한의원 사당이수점", orgNameEn: "Sadang Isu KKEUT Clinic" },

  // 비급여 안내의 병원명 표기 (#872 — 페이지에 박혀 있던 값).
  // 지금은 읽는 곳이 없다 (#892). 공유본이 6월에 상단 노출을 지웠다 —
  // 다시 노출하기로 하면 쓸 값이라 남겨 둔다.
  // branchTitle·titleTail 과 섞여 있어 유도할 수 없어 그대로 옮겼다.
  uncoveredFeesHospital: {"ko":"사당이수 끗 한의원","en":"Sadang Isu KKEUT Korean Clinic","ja":"Sadang Isu KKEUT韓医院","zh":"Sadang Isu KKEUT韩医院"},

  // 푸터의 지점 표기 (#861 — 래퍼에 박혀 있던 값).
  branchTitle: {"ko":"사당이수 끗 한의원","en":"KKEUT Sadang Isu","ja":"KKEUT韓医院（Sadang Isu）","zh":"KKEUT韩医院（Sadang Isu）","th":"KKEUT Sadang Isu"},
  // 홈 소셜 섹션 (#861). 기존 social 키와 쓰임이 달라 분리한다.
  socialShowcase: {
    overline: { ko: "끗 한의원 사당이수점" },
    youtube: "",
    instagram: "",
  },
  fallbackDomain: "https://www.kkeutclinic-sadang.co.kr",
  titleTail: {
    ko: "사당이수 끗 한의원",
    en: "Sadang Isu KKEUT Korean Clinic",
    ja: "Sadang Isu KKEUT韓医院",
    zh: "Sadang Isu KKEUT韩医院",
    th: "Sadang Isu KKEUT Korean Clinic",
  },
  areaPrefix: {
    ko: "사당 이수 사당역 이수역 총신대입구역 사당동 남현동 방배동 동작구 관악구",
    en: "Sadang, Isu, Sadang Station, Isu Station, Chongshin University Station, Sadang-dong, Namhyeon-dong, Bangbae-dong, Dongjak-gu, Gwanak-gu",
    ja: "舎堂、梨水、舎堂駅、梨水駅、総神大入口駅、舎堂洞、南峴洞、方背洞、銅雀区、冠岳区",
    zh: "舍堂、梨水、舍堂站、梨水站、总神大入口站、舍堂洞、南岘洞、方背洞、铜雀区、冠岳区",
  },
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
  homeDesc: {
    ko: "인근 한의원. 사당이수 리프팅 · 제모 · 여드름 · 피부과 시술부터 다이어트/약침/부종 관리까지 한 번에 상담하세요.",
    en: "Korean medicine & aesthetics clinic in Sadang Isu. Lifting, laser/toning, hair removal, acne care, diet and pharmacopuncture — in Sadang Isu.",
    ja: "Sadang Isuエリアの韓方×美容クリニック。リフティング、レーザー/トーニング、脱毛、ニキビケア、ダイエット、薬鍼まで一ヶ所でご相談いただけます。",
    zh: "位于Sadang Isu的韩方+皮肤诊所。提升、激光/焕肤、脱毛、痘痘护理、减脂、药针，在Sadang Isu一次完成。",
  },
  homeKeywords: {
    ko: ["사당이수 한의원","사당이수 한의원","사당이수 끗 한의원","사당이수 한의원","사당이수 피부과","사당이수 리프팅","사당이수 약침","사당이수 레이저토닝","사당이수 제모","사당이수 여드름","사당이수 스킨부스터","사당이수 다이어트 한의원","사당이수 한의원"],
    en: ["KKEUT Clinic Sadang Isu","Sadang Isu clinic","Korean medicine","lifting","acne care","laser toning","hair removal","diet program","pharmacopuncture"],
    ja: ["Sadang Isu 韓医院","Sadang Isu クリニック","リフティング","ニキビケア","レーザートーニング","医療脱毛","ダイエット"],
    zh: ["Sadang Isu 韩医院","Sadang Isu 诊所","皮肤管理","提升","痘痘护理","激光焕肤","脱毛","减肥诊所"],
  },
  policyHospitalName: {
    ko: "사당이수 끗 한의원",
    en: "Sadang Isu",
    ja: "Sadang Isu",
    zh: "Sadang Isu",
  },

  // 화면별 SEO 문구 — 단일앱에서는 파일이 하나뿐이라 지점 데이터는
  // 전부 설정으로 와야 한다 (#846).
  seo: {
    networkLayout: {
      sameAs: [
      ],
      i18n: {
      title: {
        ko: "사당이수 끗 한의원, 한 끗 차이의 아름다움",
        en: "Sadang Isu KKEUT Clinic — The Beauty in Detail",
        ja: "Sadang Isu KKEUT 韓医院 — ひとすじ違いの美しさ",
        zh: "Sadang Isu KKEUT韩医院 — 一线之差的美",
      },
      desc: {
        ko: "전국 피부·다이어트·리프팅 전문 한의원 네트워크",
        en: "Nationwide Korean medicine clinic network for skin, diet, and lifting",
        ja: "全国の皮膚・ダイエット・リフティング専門 韓方クリニック ネットワーク",
        zh: "全国皮肤/减肥/提升 专业韩医诊所网络",
      },
      ogLocale: { ko: "ko_KR", en: "en_US", ja: "ja_JP", zh: "zh_CN" },
    },
    },
    beforeDetail: {
  defaultKeywords: {
    ko: [
      "사당이수 전후사진",
      "사당이수 시술 전후",
      "사당이수 피부과 전후사진",
      "사당이수 리프팅 전후",
      "사당이수 여드름 치료 전후",
      "사당이수 제모 전후",
      "사당이수 필러 전후",
      "사당이수 보톡스 전후",
      "사당이수 피부과",
      "사당이수 끗 한의원 전후사진",
    ],
    en: [
      "sadang before and after",
      "sadang skin clinic photos",
      "sadang lifting before after",
      "sadang acne treatment before after",
      "sadang filler before after",
      "korean clinic before after sadang",
    ],
    ja: [
      "Sadang Isu ビフォーアフター",
      "Sadang Isu 美容クリニック 症例写真",
      "Sadang Isu リフティング ビフォーアフター",
      "Sadang Isu ニキビ治療 症例",
      "韓国 Sadang Isu 施術 前後",
    ],
    zh: [
      "Sadang Isu 术前术后",
      "Sadang Isu 美容 术前术后 照片",
      "Sadang Isu 提拉 前后对比",
      "Sadang Isu 痘痘治疗 前后对比",
      "韩国Sadang Isu 医美 案例",
    ],
  },
    },
    mainLayout: {
  branchId: "sadang",
  i18n: {
    title: {
      ko: "사당이수 끗 한의원, 한 끗 차이의 아름다움",
      en: "Sadang Isu KKEUT Korean Medicine Clinic, Beauty in One Fine Difference",
      ja: "Sadang Isu KKEUT韓医院、ひとすじ違いの美しさ",
      zh: "Sadang Isu KKEUT韩医院，一线之差的美",
    },
    desc: {
      ko: "사당이수 한의원. 사당이수 리프팅, 사당이수 약침, 사당이수 레이저토닝, 사당이수 제모, 사당이수 여드름, 사당이수 스킨부스터까지 한 번에 상담하세요.",
      en: "Korean medicine & dermatology clinic in Sadang Isu. Lifting, acupuncture, laser toning, hair removal, acne care, skin boosters — in Sadang Isu.",
      ja: "Sadang Isuエリアの韓方×美容クリニック。リフティング、薬鍼、レーザートーニング、脱毛、ニキビケア、スキンブースターなどに対応します。",
      zh: "位于Sadang Isu的韩方+皮肤诊所。提升、药针、激光焕肤、脱毛、痘痘护理、皮肤补剂等项目，一站式完成。",
    },
    keywords: {
      ko: ["사당이수 한의원","사당이수 한의원","사당이수 끗 한의원","사당이수 한의원","사당이수 피부과","사당이수 리프팅","사당이수 약침","사당이수 레이저토닝","사당이수 제모","사당이수 여드름","사당이수 스킨부스터","사당이수 다이어트 한의원","사당이수 한의원"],
      en: ["KKEUT Clinic Sadang Isu","Sadang Isu clinic","Korean medicine","lifting","acupuncture","laser toning","hair removal","acne care","skin booster","diet program"],
      ja: ["Sadang Isu 韓医院","Sadang Isu クリニック","リフティング","薬鍼","レーザートーニング","脱毛","ニキビケア","スキンブースター"],
      zh: ["Sadang Isu 韩医院","Sadang Isu 诊所","皮肤管理","提升","激光嫩肤","脱毛","痘痘护理","皮肤补剂"],
    },
    ogLocale: { ko: "ko_KR", en: "en_US", ja: "ja_JP", zh: "zh_CN" },
  },
  areaPrefix: {
    ko: "사당 이수 사당역 이수역 총신대입구역 사당동 남현동 방배동 동작구 관악구",
    en: "Sadang, Isu, Sadang Station, Isu Station, Chongshin University Station, Sadang-dong, Namhyeon-dong, Bangbae-dong, Dongjak-gu, Gwanak-gu",
    ja: "舎堂、梨水、舎堂駅、梨水駅、総神大入口駅、舎堂洞、南峴洞、方背洞、銅雀区、冠岳区",
    zh: "舍堂、梨水、舍堂站、梨水站、总神大入口站、舍堂洞、南岘洞、方背洞、铜雀区、冠岳区",
  },
  orgName: {
    ko: "사당이수 끗 한의원",
    en: "Sadang Isu KKEUT Korean Clinic",
  },
  sameAs: [
    "https://www.kkeutclinic-sadang.co.kr",
  ],
  naverFallback: "", // 미정 TODO — 사이트 소유확인 코드
  googleFallback: "", // 미정 TODO — 사이트 소유확인 코드
    },
    skinNoteDetail: {
  baseTitle: {
    ko: "시술 노트 | 사당이수 끗 한의원",
    en: "Procedure Notes | Sadang Isu KKEUT Korean Clinic",
    ja: "施術ノート | Sadang Isu KKEUT韓医院",
    zh: "项目笔记 | Sadang Isu KKEUT韩医院",
  },
  baseDesc: {
    ko: "시술 원리, 전후 관리, 케이스 인사이트를 정리한 사당이수 끗 한의원 시술 노트 상세 페이지입니다.",
    en: "Sadang Isu KKEUT Clinic procedure note — principles, aftercare, and case insights.",
    ja: "Sadang IsuKKEUT韓医院の施術ノート詳細ページです。施術原理、アフターケア、症例のポイントをまとめました。",
    zh: "Sadang Isu KKEUT韩医院项目笔记详情页：原理、术后护理与案例要点。",
  },
  defaultKeywords: {
    ko: [
      "사당이수 시술 노트",
      "사당이수 끗 한의원",
      "사당이수 피부 시술",
      "레이저",
      "리프팅",
      "토닝",
      "제모",
      "여드름",
      "흉터",
      "색소",
    ],
    en: [
      "Sadang Isu procedure notes",
      "Sadang Isu dermatology",
      "laser",
      "lifting",
      "toning",
      "hair removal",
      "acne",
      "scar",
      "pigmentation",
    ],
    ja: [
      "Sadang Isu 施術ノート",
      "Sadang Isu 皮膚",
      "レーザー",
      "リフティング",
      "トーニング",
      "脱毛",
      "ニキビ",
      "瘢痕",
      "色素",
    ],
    zh: [
      "Sadang Isu 项目笔记",
      "Sadang Isu 皮肤",
      "激光",
      "提升",
      "嫩肤",
      "脱毛",
      "痤疮",
      "疤痕",
      "色素",
    ],
  },
    },
    clinicPriceDetail: {
  baseDesc: {
    ko: "사당이수 끗 한의원의 시술 상세 페이지입니다. 시술 설명, 가격, 시술 후 주의사항을 확인하세요.",
    en: "Detailed procedure page for KKEUT Clinic Sadang Isu. Check description, pricing and aftercare.",
    ja: "KKEUT韓医院 Sadang Isu院の施術詳細ページです。施術内容・価格・注意事項をご確認ください。",
    zh: "Sadang Isu KKEUT韩医院的项目详情页。可查看项目内容、价格及术后注意事项。",
  },
  defaultKeywords: {
    ko: ["사당이수 끗 한의원", "사당이수 피부과 시술", "사당이수 레이저", "사당이수 리프팅", "사당이수 여드름", "사당이수 제모", "사당이수 피부과", "사당이수 한의원"],
    en: ["sadang treatment", "sadang skin clinic", "sadang laser clinic", "korean skin clinic sadang"],
    ja: ["Sadang Isu 施術", "Sadang Isu 美容クリニック", "Sadang Isu レーザー", "韓国 美容 クリニック Sadang Isu"],
    zh: ["Sadang Isu 皮肤科", "Sadang Isu 美容诊所", "Sadang Isu 激光 项目", "韩国 Sadang Isu 韩医院"],
  },
  areaServed: "Sadang Isu, Korea",
    },
    uncoveredFees: {
  keywords: {
  ko: ["비급여 진료비용", "비급여 안내", "시술 비용", "끗 한의원 비용"],
  en: ["non-covered fees", "korean clinic price", "kkeut clinic fee guide"],
  ja: ["保険外診療費", "施術費用", "韓医院 費用"],
  zh: ["非医保费用", "诊疗费用", "韩医院价格"]
},
    },
    reserve: {
  pageLabel: {
  ko: "온라인 예약",
  en: "Online Reservation",
  ja: "オンライン予約",
  zh: "在线预约"
},
  desc: {
  ko: "사당이수 끗 한의원 간편 온라인 예약. 피부, 다이어트, 리프팅 시술 예약하기.",
  en: "Easy online booking for KKEUT Clinic Sadang Isu. Skin, Diet, Lifting.",
  ja: "Sadang IsuのKKEUT韓医院、簡単オンライン予約。皮膚・ダイエット・リフティング。",
  zh: "Sadang Isu KKEUT韩医院便捷在线预约。皮肤/减肥/提升项目。"
},
  robots: { index: false, follow: false },
    },
    doctors: {
  fallbackRegion: "사당이수",
  keywords: [
    "사당이수 한의원 원장 소개",
    "사당이수 한의원",
    "사당이수 피부과 시술",
    "사당이수 레이저토닝",
    "사당이수 리프팅",
    "사당이수 제모",
    "사당이수 피부미용",
    "사당이수 보톡스",
    "사당이수 필러",
    "사당이수 여드름",
    "사당이수 점·잡티 제거",
    "사당이수 실리프팅",
    "사당이수 비만/체형",
    "사당이수 지방분해주사",
    "끗 한의원 의료진",
    "사당이수 스킨부스터",
  ],
    },
    rssNote: {
  keywords: {
    ko: [
      "사당이수 끗 한의원",
      "사당이수 피부과",
      "사당이수 레이저 시술",
      "사당이수 제모 클리닉",
      "사당이수 리프팅",
      "사당이수 다이어트 한의원",
      "사당이수 여드름 한의원",
      "사당이수 피부과",
      "사당이수 한의원",
    ],
    en: [
      "Sadang Isu skin clinic",
      "Sadang Isu KKEUT Clinic",
      "Sadang Isu laser treatment",
      "Sadang Isu lifting clinic",
      "Korean medicine dermatology",
      "Sadang Isu tattoo removal",
    ],
    ja: [
      "Sadang Isu 皮膚 クリニック",
      "Sadang Isu 韓医院",
      "Sadang Isu レーザー 施術",
      "Sadang Isu リフティング",
      "韓方 ダイエット Sadang Isu",
    ],
    zh: [
      "Sadang Isu 皮肤科",
      "Sadang Isu 韩医院",
      "Sadang Isu 激光 美肤",
      "Sadang Isu 提升 诊所",
    ],
  },
    },
    before: {
  baseDesc: {
    ko: "{{TAIL}}에서 실제 고객이 받은 리프팅, 여드름, 제모·바디 시술의 전후 사진을 확인해보세요. 사당이수 지역 증례를 중심으로 보여드립니다.",
    en: "See real lifting, acne, contouring and body Before & After cases from {{TAIL}} in Sadang Isu.",
    ja: "Sadang Isuの{{TAIL}}で実際に施術を受けた方のビフォー＆アフター症例です。リフティング・ニキビ・痩身などを写真で確認できます。",
    zh: "在{{TAIL}}（Sadang Isu）查看真实顾客的术前术后对比，包含提升、痘痘治疗、体形管理等案例。",
  },
  keywords: {
    ko: ["사당이수 전후사진","사당이수 시술 전후","사당이수 피부과 전후사진","사당이수 리프팅 전후","사당이수 여드름 치료 전후","사당이수 제모 전후","사당이수 필러 전후","사당이수 보톡스 전후","사당이수 피부과","사당이수 끗 한의원 전후사진"],
    en: ["sadang before and after","sadang skin clinic photos","sadang lifting before after","sadang acne treatment before after","sadang filler before after","korean clinic before after sadang"],
    ja: ["Sadang Isu ビフォーアフター","Sadang Isu 美容クリニック 症例写真","Sadang Isu リフティング ビフォーアフター","Sadang Isu ニキビ治療 症例","韓国 Sadang Isu 施術 前後"],
    zh: ["Sadang Isu 术前术后","Sadang Isu 美容 术前术后 照片","Sadang Isu 提拉 前后对比","Sadang Isu 痘痘治疗 前后对比","韩国Sadang Isu 医美 案例"],
  },
    },
    blogNote: {
  baseDesc: {
    ko: "사당이수 끗 한의원 원장 블로그. 피부·리프팅·제모·여드름 시술 원리와 실제 케이스, 사후 관리 팁을 정리했습니다.",
    en: "KKEUT Clinic director's blog in Sadang Isu — treatment principles, real cases and aftercare tips.",
    ja: "Sadang IsuにあるKKEUT韓医院 院長ブログ。施術の考え方、実例、アフターケアのポイントをまとめました。",
    zh: "Sadang Isu KKEUT韩医院 院长博客：项目原理、真实案例、术后护理重点。",
  },
  keywords: {
    ko: [
      "사당이수 피부과 블로그",
      "사당이수 시술 후기",
      "사당이수 레이저토닝",
      "사당이수 기미 색소 치료",
      "사당이수 여드름 치료",
      "사당이수 리프팅",
      "사당이수 제모",
      "사당이수 피부과",
      "사당이수 끗 한의원",
      "사당이수 피부과",
    ],
    en: [
      "sadang skin clinic blog",
      "sadang dermatology",
      "korean aesthetic treatments sadang",
      "laser toning sadang",
      "lifting in sadang",
      "acne treatment sadang",
    ],
    ja: [
      "Sadang Isu 美容 クリニック ブログ",
      "Sadang Isu 皮膚科 韓国 施術",
      "Sadang Isu レーザートーニング",
      "Sadang Isu リフティング 施術",
      "Sadang Isu ニキビ 治療",
    ],
    zh: [
      "Sadang Isu 皮肤科 博客",
      "Sadang Isu 美容医院 韩国",
      "Sadang Isu 激光 美白",
      "Sadang Isu 提拉 项目",
      "Sadang Isu 痘痘 治疗",
    ],
  },
    },
    cart: {
      descArea: { ko: "사당이수", en: "Sadang Isu", ja: "Sadang Isu", zh: "Sadang Isu" },
      kwMap: {
  ko: [
    "사당이수 끗 한의원",
    "사당이수 피부과 예약",
    "사당이수 한의원 시술",
    "사당이수 장바구니",
    "사당이수 레이저 제모",
    "사당이수 여드름 치료",
    "사당이수 리프팅",
    "사당이수 피부과",
    "사당이수 시술 예약",
  ],
  en: [
    "sadang clinic cart",
    "sadang skin clinic",
    "sadang laser booking",
    "sadang hair removal",
    "sadang acne treatment",
    "korean aesthetic clinic",
  ],
  ja: [
    "Sadang Isu クリニック 予約",
    "Sadang Isu 美容",
    "Sadang Isu レーザー 施術",
    "Sadang Isu 脱毛 予約",
    "韓国 美容 クリニック",
  ],
  zh: [
    "Sadang Isu 韩医院",
    "Sadang Isu 皮肤科",
    "Sadang Isu 美容 项目 预约",
    "Sadang Isu 激光 脱毛",
    "韩国 美容 诊所 Sadang Isu",
  ],
},
  robots: { index: false, follow: false },
    },
    kkeut: {
  defaultDesc: {
    ko: "사당이수 일대에서 피부·다이어트·리프팅 중심의 맞춤 한방 진료를 제공합니다. 병원 철학, 진료 방향, 시설 정보를 확인해보세요.",
    en: "A Korean medicine clinic in Sadang Isu focused on skin, diet and lifting. Read about our philosophy, care approach and facilities.",
    ja: "Sadang Isuエリアで、皮膚・ダイエット・リフティングに特化した韓方クリニックです。理念・診療方針・設備情報をご覧ください。",
    zh: "位于Sadang Isu，专注皮肤、减肥与提升的韩医诊所。查看我们的理念、诊疗方向与设施信息。",
  },
  defaultKw: {
    ko: [
      "사당이수 피부과",
      "사당이수 피부과",
      "사당이수 미용의원",
      "사당이수 피부과 추천",
      "사당이수 여드름치료",
      "사당이수 제모",
      "사당이수 레이저제모",
      "사당이수 리프팅",
      "사당이수 보톡스",
      "사당이수 필러",
      "사당이수 기미잡티",
      "사당이수 스킨부스터",
      "사당이수 다이어트 한의원",
      "사당이수 한방 다이어트",
      "사당이수 피부과",
    ],
    en: [
      "sadang skin clinic",
      "skin clinic sadang",
      "sadang dermatology clinic",
      "korean beauty clinic sadang",
      "sadang laser clinic",
      "sadang laser hair removal",
      "sadang acne treatment",
      "sadang lifting treatment",
      "sadang botox",
      "sadang filler",
      "sadang skin booster",
      "korean traditional medicine clinic sadang",
    ],
    ja: [
      "Sadang Isu 皮膚科",
      "Sadang Isu 美容クリニック",
      "韓国 Sadang Isu 皮膚クリニック",
      "Sadang Isu レーザー治療",
      "Sadang Isu シミ取り",
      "Sadang Isu リフティング",
      "Sadang Isu ボトックス",
      "Sadang Isu フィラー",
      "Sadang Isu 脱毛 クリニック",
      "Sadang Isu 韓国美容",
    ],
    zh: [
      "Sadang Isu 皮肤科",
      "韩国Sadang Isu 皮肤管理",
      "Sadang Isu 医美 诊所",
      "Sadang Isu 激光祛斑",
      "Sadang Isu 脱毛",
      "Sadang Isu 提拉",
      "Sadang Isu 除皱针",
      "Sadang Isu 痘痘治疗",
      "Sadang Isu 韩医院 皮肤",
      "韩国Sadang Isu 美容诊所 推荐",
    ],
  },
    },
    remoteReserve: {
      descArea: { ko: "사당이수", en: "Sadang Isu", ja: "Sadang Isu", zh: "Sadang Isu" },
      kw: {
  ko: [
    "비대면 진료",
    "원격 진료",
    "온라인 진료",
    "사당이수 비대면 진료",
    "사당이수 비대면 진료",
    "사당이수 진구 비대면 진료",
    "원격진료 예약",
    "텔레메디슨",
    "끗 한의원 사당이수",
    "KKEUT Clinic",
  ],
  en: [
    "telemedicine",
    "remote care",
    "online clinic",
    "Sadang Isu telemedicine",
    "Sadang Isu telemedicine",
    "reservation",
    "KKEUT Clinic",
  ],
  ja: [
    "オンライン診療",
    "遠隔診療",
    "Sadang Isu オンライン診療",
    "Sadang Isu オンライン診療",
    "予約",
    "KKEUT 韓医院",
  ],
  zh: [
    "线上就诊",
    "远程医疗",
    "Sadang Isu 线上诊疗",
    "Sadang Isu 线上诊疗",
    "预约",
    "KKEUT 韩医院",
  ],
},
  google: "", // 미정 TODO — 사이트 소유확인 코드
  robots: { index: false, follow: false },
    },
    skinNote: {
  baseDesc: {
    ko: "사당이수 끗 한의원의 시술 노트를 한눈에. 시술 원리, 전후 관리, 케이스 인사이트를 정리했습니다.",
    en: "Browse KKEUT Clinic Sadang Isu's procedure notes — principles, aftercare tips, and case insights in one place.",
    ja: "Sadang IsuのKKEUT韓医院の施術ノートです。施術原理、アフターケア、症例のポイントをまとめました。",
    zh: "集中查看Sadang Isu KKEUT韩医院的项目笔记：原理、术后护理与案例要点，一站式掌握。",
  },
  keywords: {
    ko: [
      "사당이수 끗 한의원",
      "사당이수 시술 노트",
      "사당이수 피부 시술",
      "레이저",
      "리프팅",
      "토닝",
      "제모",
      "여드름",
      "흉터",
      "색소",
    ],
    en: [
      "Sadang Isu procedure notes",
      "Sadang Isu dermatology",
      "laser",
      "lifting",
      "toning",
      "hair removal",
      "acne",
      "scar",
      "pigmentation",
    ],
    ja: [
      "Sadang Isu 施術ノート",
      "Sadang Isu 皮膚",
      "レーザー",
      "リフティング",
      "トーニング",
      "脱毛",
      "ニキビ",
      "瘢痕",
      "色素",
    ],
    zh: [
      "Sadang Isu 项目笔记",
      "Sadang Isu 皮肤",
      "激光",
      "提升",
      "嫩肤",
      "脱毛",
      "痤疮",
      "疤痕",
      "色素",
    ],
  },
  siteName: {
    ko: "끗 한의원 사당이수",
    en: "KKEUT Clinic Sadang Isu",
    ja: "KKEUT韓医院 Sadang Isu",
    zh: "KKEUT韩医院 Sadang Isu",
  },
    },
    network: {
  fallbackDomain: "https://www.kkeutclinic-sadang.co.kr"
,
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
    },
    clinicPrice: {
      supported: ["ko", "en", "ja", "zh"],
      jsonLdName: { ko: "사당이수 시술 목록", en: "Clinic Treatments - Sadang Isu" },
  baseDesc: {
    ko: "사당이수 끗 한의원의 시술/이벤트 안내입니다. 레이저·리프팅·제모·여드름·흉터 등 시술별 상세 정보를 확인하세요.",
    en: "Treatments and event information for KKEUT Clinic in Sadang Isu. Find details for laser, lifting, hair removal, acne and scar care.",
    ja: "Sadang Isu KKEUT韓医院の施術/イベント案内です。レーザー、リフティング、脱毛、ニキビ・瘢痕治療の詳細をご覧ください。",
    zh: "Sadang Isu KKEUT韩医院的项目和活动信息。查看激光、提升、脱毛、痘痘与疤痕治疗的详细说明。",
  },
  keywords: {
    ko: [
      "사당이수 시술",
      "사당이수 레이저토닝",
      "사당이수 제모",
      "사당이수 리프팅",
      "사당이수 여드름",
      "사당이수 피부과 시술",
      "사당이수 피부과",
      "사당이수 피부과 이벤트",
    ],
    en: [
      "Sadang Isu laser",
      "Sadang Isu lifting",
      "Sadang Isu treatment",
      "Sadang Isu skincare",
      "Sadang Isu dermatology event",
      "hair removal Sadang Isu",
    ],
    ja: [
      "Sadang Isu レーザー",
      "Sadang Isu リフティング",
      "Sadang Isu 施術",
      "Sadang Isu レーザー",
      "Sadang Isu 皮膚科 イベント",
    ],
    zh: [
      "Sadang Isu 激光",
      "Sadang Isu 提升",
      "Sadang Isu 项目",
      "Sadang Isu 激光",
      "Sadang Isu 皮肤科 活动",
    ],
  },
  siteName: {
    ko: "끗 한의원",
    en: "KKEUT Clinic",
    ja: "KKEUT Clinic",
    zh: "KKEUT Clinic",
  },
  naver: "", // 미정 TODO — 사이트 소유확인 코드
  google: "", // 미정 TODO — 사이트 소유확인 코드
    },
  },


  // config/branch.js 에 있던 지점 정보 (#851).

  // 본인인증 수단 — 지점 단일 출처 (#835).
  // 예약·예약확인·비대면예약·전후사진·마이페이지가 모두 이 값 하나를 쓴다.
  // 화면마다 따로 두었더니 같은 지점 안에서도, 언어별로도 값이 갈렸다.
  ivChannels: [], // 미정 TODO — 카카오 심사 완료 전 인증 수단 숨김
  branchName: {"ko":"사당이수점","en":"Sadang Isu","ja":"Sadang Isu店","zh":"Sadang Isu店"},
  domain: "www.kkeutclinic-sadang.co.kr",
  phone: "", // 미정 TODO
  address: "", // 미정 TODO
  businessNumber: "", // 미정 TODO
  naverLink: "", // 미정 TODO
  kakaoLink: "", // 미정 TODO
  // location / businessHours / social / menu 등은
  // 후속 컴포넌트 추출 시점에 채워 넣음 (Footer, Location 등 작업 단계).
  locales: ["ko", "en", "ja", "zh", "th"],
  defaultLocale: "ko",
  // 요양기관번호·호스트는 서버 전용이라 config 에 두지 않는다
  // (api/reservation/create 라우트가 env 로 주입). 아래는 화면이 쓰는 값이다.
  vegas: null, // 미정 TODO — 베가스 조직번호 미정, 전송 금지
  reserve: {
    enableIdentity: false, // 미정 TODO — 심사 전 수기 예약
    smsAgreeKo: "사당이수 끗 한의원에서 발송하는 시술안내, 공지 등 문자 수신에 동의합니다. (선택)",
  },
  remotePay: { enabled: false }, // 미정 TODO — 결제선생 회원/가맹점 ID
  // 미정 TODO — bssm 원본의 Facebook Pixel ID 미설정 상태 유지
  // 비대면예약 화면 (#835)
  remote: {
    enableIdentity: false, // 미정 TODO — 카카오 심사 전 수기 입력
    manualReservation: true, // 미정 TODO — 결제 없이 예약 접수만 진행
  },

};
